import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { VerificationDataType } from '../../../../models/dashboard/settings/profileSettings/verification.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../../../models/https';
import { useAppSelector } from '../../../../redux/store';
import useHttps from '../../../useHttps';
import useGetUserData from '../useGetUserData';

const useEditVerification = () => {
  const { authData } = useAppSelector((state) => state.auth);
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const { getUserData } = useGetUserData();

  const onEditVerificationError = (err: AxiosError<ErrorHttpResponse>) => {
    toast.error(
      err?.response?.data?.message ??
        'Something went wrong while editing verification data'
    );
  };

  const onEditVerificationSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    if (message) {
      toast.success(message);
    } else {
      toast.success('successful');
    }
    getUserData();
  };

  // const createVerification = (data: VerificationDataType) => {
  const editVerification = async (data: VerificationDataType) => {
    const formData = new FormData();

    const yearOfCurrentLicense =
      data.yearOfCurrentLicense instanceof Date
        ? data.yearOfCurrentLicense.toISOString().split('T')[0]
        : data.yearOfCurrentLicense;

    formData.append('yearOfCurrentLicense', yearOfCurrentLicense);
    formData.append('primaryDegreeName', data.primaryDegreeName);
    formData.append('validationNumber', data.validationNumber);

    if (data.license instanceof File) {
      formData.append('license', data.license);
    }

    if (data.primaryDegreeCertificate instanceof File) {
      formData.append(
        'primaryDegreeCertificate',
        data.primaryDegreeCertificate
      );
    }

    const url: HttpConfig = {
      url: `auth-service/users/verifications/${authData?.verification?.id}`,
      method: 'put',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
    request(
      url,
      onEditVerificationSuccess,
      setLoading,
      onEditVerificationError
    );
  };

  return { editVerification, loading };
};

export default useEditVerification;
